import React, { useState } from "react";
import useSearch from "../custom-hooks/useSearch";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
import SearchResultsDropdown from "./CustomSearchResultDropdown";
import useRfiSearch from "../custom-hooks/useRfiSearch";

const Searchbar = ({
  height,
  width,
  placeholder,
  isFilterSearch,
  onSearch,
  isSearchIcon,
  isProviderSearch,
  marginRight,
  resetFilters,
  mainSearch,
  onChange,
  setSearchQuery,
  handleClearSearch,
}) => {
  const searchHook = isProviderSearch ? useSearch : useRfiSearch;

  const {
    searchText,
    showResults,
    results,
    isLoading,
    isError,
    handleSearchTextChange,
    handleSearch,
    handleResultClick,
    setSearchText,
  } = searchHook(isFilterSearch, onSearch, resetFilters);

  const [isResultClicked, setIsResultClicked] = useState(false);

  const onResultClick = (provider) => {
    const ids = provider.id || provider?.rfi_id;

    handleResultClick(provider);
    onSearch(ids);
    setIsResultClicked(true);
  };

  const handleClearAll = () => {
    setSearchText("");
    handleClearSearch();
  };

  return (
    <div
      className={`relative ${marginRight}`}
      style={{ width: width, height: height }}
    >
      <input
        type="search"
        value={searchText}
        placeholder={placeholder}
        onChange={(e) => {
          handleSearchTextChange(e); // Always update local state
          setIsResultClicked(false);
          if (mainSearch) {
            onChange(e); // Call parent handler if needed
          }
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleSearch(e);
          }
        }}
        className={`w-full h-full py-2 px-4 pr-8 bg-white border-2 border-gray-300 rounded-lg 
              font-hurme text-sm font-normal text-left 
              placeholder-gray-400 text-black focus:text-black ${
                isResultClicked ? "text-[11px]" : "text-sm"
              }`}
      />

      {isSearchIcon && !searchText && (
        <button
          onClick={handleSearch}
          className="absolute inset-y-0 right-2 flex items-center px-2 text-gray-700 bg-transparent ml-3"
        >
          <MagnifyingGlassIcon className="h-5 w-5 text-custom-464255-color" />
        </button>
      )}
      {searchText && mainSearch && (
        <button
          onClick={handleClearAll}
          className="absolute inset-y-0 right-2 flex items-center px-2 text-gray-700 bg-transparent"
        >
          <XMarkIcon
            className="text-black"
            style={{ width: "15px", height: "15px" }}
          />
        </button>
      )}

      {isFilterSearch && searchText?.length >= 2 && showResults && (
        <SearchResultsDropdown
          isLoading={isLoading}
          isError={isError}
          results={results}
          handleResultClick={onResultClick}
          isProviderSearch={isProviderSearch}
        />
      )}
    </div>
  );
};

export default Searchbar;
